"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicedUploadImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var useUploadFile_1 = __importStar(require("../../hooks/useUploadFile"));
var TrackEventProvider_1 = require("../Providers/TrackEventProvider");
var UploadImage_1 = __importDefault(require("../UploadImage"));
var ServicedUploadImage = function (_a) {
    var _b = _a.endpointUrl, endpointUrl = _b === void 0 ? useUploadFile_1.HOSTS['staging'] : _b, props = __rest(_a, ["endpointUrl"]);
    var _c = (0, useUploadFile_1.default)(endpointUrl), uploadImage = _c.uploadImage, response = _c.response, loading = _c.loading, error = _c.error, reset = _c.reset;
    return ((0, jsx_runtime_1.jsx)(TrackEventProvider_1.TrackingEventsContextProvider, { children: (0, jsx_runtime_1.jsx)(UploadImage_1.default, __assign({}, props, { loading: loading, errors: error ? [error] : undefined, handleUploadImage: uploadImage, uploadedSource: response === null || response === void 0 ? void 0 : response.downloadUrl, onModalClose: function () {
                reset();
            } }), void 0) }, void 0));
};
exports.ServicedUploadImage = ServicedUploadImage;
exports.default = exports.ServicedUploadImage;
